import * as S from "./styles";
import { useFormComplaint } from "./useFormComplaint";
import dayjs from "dayjs";
import { Input } from "../../Atoms/Inputs/Input";
import { SimpleSelect } from "../../Atoms/Selects/SimpleSelect";
import { Button } from "../../Atoms/Button";
import { InputCheckbox } from "../../Atoms/InputCheckbox/inputCheckbox";

import { CardWitness } from "../../Atoms/CardWitness/cardWitness";
import { InputRadio } from "../../Atoms/InputRadio/inputRadio";
import { LayoutTemplate } from "../../Templates/LayoutTemplate";
import { TextArea } from "../../Atoms/TextArea";
import { v4 } from "uuid";

export const FormComplaint = () => {
  const { data, downloadImagemPorUUID } = useFormComplaint();

  return (
    <LayoutTemplate title="Denuncias de Abuso">
      <S.Container>
        <S.FormComplaintStyle>
          <div>
            <h2>Dados da Denúncia</h2>
          </div>

          <div>
            <h3>Dados do Colaborador</h3>
          </div>

          <S.FormFieldsAnonymous>
            <div>
              <Input value={data.nome_colaborador} disabled label="Nome" />
            </div>

            <div>
              <Input
                value={
                  data.data_admissao &&
                  dayjs(data.data_admissao).format("DD/MM/YYYY")
                }
                disabled
                label="Data de Admissão"
              />
            </div>

            <div>
              <Input value={data.cargo_colaborador} disabled label="Cargo" />
            </div>

            <div>
              <Input
                value={data.setor_colaborador}
                disabled
                label="Setor/Departamento/Empresa"
              />
            </div>
          </S.FormFieldsAnonymous>

          <div>
            <h3>Dados do Acusado</h3>
          </div>

          <S.FormFieldsAccused>
            <div>
              <Input value={data.nome_acusado} disabled label="Nome" />
            </div>
            <div>
              <Input value={data.cargo_acusado} disabled label="Cargo" />
            </div>
            <div>
              <Input
                value={data.setor_acusado}
                disabled
                label="Setor/Departamento/Empresa"
              />
            </div>
            <div>
              <Input
                value={data.tipo_assedio}
                disabled
                label="Tipo de Assédio"
              />
            </div>
          </S.FormFieldsAccused>

          <div>
            <h3>Descrição</h3>
          </div>

          <S.FormFieldsDescription>
            <div>
              <Input
                value={data && dayjs(data.data_ocorrencia).format("DD/MM/YYYY")}
                disabled
                label="Data"
              />
            </div>

            <div>
              <Input value={data.localizacao} disabled label="Local" />
            </div>

            <div>
              <TextArea
                value={data.descricao}
                disabled
                label="Descrição do Assédio"
              />
            </div>
          </S.FormFieldsDescription>
          {data?.testemunhas?.length > 0 && (
            <div>
              <h3>Testemunhas</h3>
            </div>
          )}
          <S.WrapperCardsWitness>
            {data?.testemunhas?.length > 0 &&
              data?.testemunhas?.map((t) => (
                <CardWitness key={v4()} nome={t.nome} cargo={t.cargo} />
              ))}
          </S.WrapperCardsWitness>

          <div>
            <h3>Medidas Tomadas</h3>
          </div>

          <S.Questions>
            <S.WrapperQuestion>
              <p>Procurou um superior?</p>

              <div>
                <InputRadio
                  checked={data.procurou_superior}
                  label="Sim"
                  disabled
                  name="procurar-superior"
                />
              </div>

              <div>
                <InputRadio
                  checked={data.procurou_superior === false}
                  label="Não"
                  disabled
                  name="procurar-superior"
                />
              </div>

              {typeof data.procurou_superior === "boolean" &&
                data.procurou_superior && (
                  <div>
                    <Input
                      value={data.nome_superior}
                      disabled
                      label="Nome do Superior"
                    />
                  </div>
                )}
            </S.WrapperQuestion>

            <S.WrapperQuestion>
              <p>Informou o RH?</p>

              <div>
                <InputRadio
                  disabled
                  checked={data.informou_rh}
                  label="Sim"
                  name="rh"
                />
              </div>

              <div>
                <InputRadio
                  disabled
                  checked={data.informou_rh === false}
                  label="Não"
                  name="rh"
                />
              </div>
            </S.WrapperQuestion>

            <S.WrapperQuestion>
              <p>Registrou Boletim de Ocorrência (B.O.)?</p>

              <div>
                <InputRadio
                  checked={data.registrou_bo}
                  label="Sim"
                  name="boletim"
                  disabled
                />
              </div>

              <div>
                <InputRadio
                  checked={data.registrou_bo === false}
                  label="Não"
                  name="boletim"
                  disabled
                />
              </div>
            </S.WrapperQuestion>

            <S.WrapperTextArea>
              <TextArea disabled label="Outras Ações Tomadas" />
            </S.WrapperTextArea>
          </S.Questions>

          <div>
            <h3>Solicitação</h3>
          </div>

          <S.FormFieldsRequest>
            <div>
              <Input
                value={data?.demanda?.split("_").join(" ")}
                disabled
                label="Demanda"
              />
            </div>
            <div>
              <TextArea
                disabled
                value={data.outras_solicitacoes}
                label="Outras solicitações"
              />
            </div>
          </S.FormFieldsRequest>

          {data?.arquivos?.length > 0 && (
            <S.SectionDownload>
              <div>
                <h3>Arquivos Anexados</h3>
              </div>

              <S.WrapperItems>
                {data?.arquivos?.map((i) => (
                  <S.item
                    key={v4()}
                    onClick={() =>
                      downloadImagemPorUUID({
                        uuid: i?.uuid,
                        nome: i?.file_name,
                      })
                    }
                  >
                    <img
                      src={
                        i?.file_type?.includes("image")
                          ? "/assets/svg/icon-doc-blue.svg"
                          : "/assets/svg/icon-voices-blue.svg"
                      }
                      alt="icone"
                    />
                    <p>{i?.file_name}</p>
                  </S.item>
                ))}
              </S.WrapperItems>
            </S.SectionDownload>
          )}
        </S.FormComplaintStyle>
      </S.Container>
    </LayoutTemplate>
  );
};
